import { RetailerNetworkPartialFragment } from '@occc/graphql';
import { LazyAutocompleteField } from '@occc-app/design-system';

import {
  makeRetailerNetworkFilter,
  mapRetailerNetworksResponseToRawArray,
  mapRetailerNetworkToAutocompleteOption,
} from './retailer-network-autocomplete.helpers';

import { useGetRetailerNetworksForUserLazyQuery } from '../../data-access/queries';

type RetailerNetworkMultipleSelectFieldProps = {
  name: string;
  label?: string;
};

export const RetailerNetworkMultipleSelectField = (
  props: RetailerNetworkMultipleSelectFieldProps,
) => (
  <LazyAutocompleteField<
    RetailerNetworkPartialFragment,
    ReturnType<typeof useGetRetailerNetworksForUserLazyQuery>['response']
  >
    label='Retailer Networks'
    {...props}
    makeQueryFilter={(search: string) => makeRetailerNetworkFilter({ search })}
    useLazyQuery={useGetRetailerNetworksForUserLazyQuery}
    mapQueryResponseToRawArray={mapRetailerNetworksResponseToRawArray}
    mapRawResponseItemToAutocompleteOption={mapRetailerNetworkToAutocompleteOption}
  />
);
